import Vue from "vue";
import Router from "vue-router";

import Layout from "@/views/layout/index.vue";
import Login from "@/views/Login.vue";
import PDFReport from "@/views/PDFReport.vue";
import HomePage from "@/views/homePage/HomePage.vue";
import groceryMarketShare from "@/views/groceryMarketShare/MarketReport/index.vue";
import CompanyManage from "@/views/groceryMarketShare/companyManage/index.vue";
import MarketReport from "@/views/marketReport/index.vue";
import MarketReportFile from "@/views/marketReport/fileList.vue";
import MarketExportRecord from "@/views/marketReport/marketExportRecord.vue";
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/pdf_report",
      name: "pdf_report",
      component: PDFReport,
    },
    {
      path: "/",
      name: "home",
      component: Layout,
      redirect: "/index",
      children: [
        {
          path: "index",
          component: HomePage,
          meta: {
            requireAuth: true,
          },
        },
      ],
    },
    {
      path: "/GroceryMarketShare",
      name: "GroceryMarketShare",
      component: Layout,
      redirect: "/index",
      children: [
        {
          path: "index",
          component: groceryMarketShare,

          meta: {
            requireAuth: true,
          },
        },
        {
          path: "CompanyManage",
          component: CompanyManage,

          meta: {
            requireAuth: true,
          },
        },
      ],
    },
    {
      path: "/MarketReport",
      name: "MarketReport",
      component: Layout,
      redirect: "/index",
      children: [
        {
          path: "index",
          component: MarketReport,

          meta: {
            requireAuth: true,
          },
        },
        {
          path: "file",
          component: MarketReportFile,

          meta: {
            requireAuth: true,
          },
        },
        {
          path: "record/:id/:name",
          component: MarketExportRecord,

          meta: {
            requireAuth: true,
          },
        },
      ],
    },
  ],
});
